export function simplifyUrl(u: any) {
    if (!u || 'string' !== typeof u) return u;
    u = u.replace(/^http[s]?:\/\//i, '');
    return u.indexOf('/') === u.length - 1 ? u.slice(0, -1) : u;
}

export default simplifyUrl;
